// extracted by mini-css-extract-plugin
module.exports = {"header":"index_header__P_1cV"};